import { useEffect } from "react";

const MessagePopup = ({ state, setState, text, icon, noTimer, containerClassName }) => {
  useEffect(() => {
    if (state && !noTimer) {
      setTimeout(() => setState(false), 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <>
      {state && (
        <>
          <div
            className="fixed top-0 left-0 w-full h-full bg-[#00000094] z-[99999]"
            onClick={() => setState(false)}
          ></div>
          <div
            className={`
              fixed flex flex-col items-center justify-center p-8 min-w-[300px] z-[99999]
              -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 rounded-2xl
              bg-white text-black dark:bg-gray-900 dark:text-white
              ${containerClassName}
            `}
          >
            {icon}
            <div className="w-full my-4 text-lg font-medium capitalize">{text}</div>
          </div>
        </>
      )}
    </>
  );
};

export default MessagePopup;
